import React from "react";
import { Row, Col, Collapse } from "antd";
import { ITripDetails } from "../../ServiceUsers/Interfaces/ITripDetails";
import getTripIcon from "../../../helpers/getTripIcon";
import { circleRightArrow } from "../../../assets/images";
import styles from "./CollapsibleTrips.module.scss";
import moment from "moment";
import ServiceUserTripDetailsMobile from "../ServiceUserTripDetailsMobile";

type Props = {
  dataSource: ITripDetails[];
};
const CollapsibleTrips: React.FC<Props> = ({ dataSource }) => {
  const { Panel } = Collapse;

  return (
    <div className={styles.scrollContainer}>
      <Collapse
        expandIcon={({ isActive }) => (
          <img
            src={circleRightArrow}
            id={isActive ? styles.rotateIcon : styles.originalIconPosition}
            alt="right arrow image"
          />
        )}
        expandIconPosition="right"
        bordered={false}
        ghost
      >
        {dataSource?.map((trip: ITripDetails, index) => (
          <Panel
            header={
              <Row align="middle" className={styles.tripRows}>
                <Col span={5}>
                  <span className={styles.tripImageLarge}>
                    {getTripIcon(trip.tripReason)}
                  </span>
                </Col>
                <Col span={16}>
                  <Row className={styles.boldText}>
                    <Col span={24}>{trip.serviceUser}</Col>
                    <Col span={24}>{trip.pickUpAddress1}</Col>
                  </Row>
                  <Row className={styles.normalText}>
                    <Col span={24}>
                      <span>
                        {moment(trip.tripDate).format("MM/DD/YYYY")} · 
                        {trip?.isWillCall
                          ? "Call when ready"
                          : moment(
                              trip?.appointmentTime || trip?.requestPickTime
                            ).format("hh:mm A")}
                      </span>
                    </Col>
                    <Col span={24}>
                      <span>${trip.tripCost} </span>
                    </Col>
                  </Row>
                </Col>
                <Col span={3} />
              </Row>
            }
            key={index + 1}
          >
            <ServiceUserTripDetailsMobile trip={trip} />
          </Panel>
        ))}
      </Collapse>
    </div>
  );
};

export default CollapsibleTrips;
